
export default class CrossCommContentAlert {
    constructor(
        public readonly id: number,
        public readonly description: string,
        public readonly allowChippedBadge: boolean,
        public readonly alertIconUrl: string,
    ) {}
}

export enum AlertIds {
    TOP_STORY_ID = 1,
    BIG_NEWS_ID = 2,
    JUST_FOR_YOU_ID = 3,
    EVENT_FOR_YOU_ID = 4,
    HAPPENING_NOW_ID = 5,
    TRENDING_ID = 6,
    PERCENT_MATCH_ID = 7,
}
